<template>
    <div v-if="r_course_list.length>0">
        <div class="recommend">
            <div class="head">
                <img class="img" src="@/assets/vodis.png" alt=""/>
                <!-- <span class="span">食品安全</span>
                <span class="span2">民以食为天，食以安为先！</span> -->
                <span class="span">热门课程</span>
                <img class="img2" src="@/assets/right.png" alt=""/>
                <!-- <span class="span3 pointer" @click="$router.push('/classify?lv1_id=42')">查看更多</span> -->
                <span class="span3 pointer" @click="$router.push('/classify')">查看更多</span>
            </div>
            <div class="one">
                <div class="commodity pointer" v-for="(item,index) in r_course_list" :key="index"
                     @click="$router.push('/Coursetobuy?course_id='+item.course_id)">
                    <div class="commoditys">
                        <img class="img" :src="item.course_img" alt=""/>
                        <img class="img1" src="@/assets/face.png" alt="" v-if="item.course_type"/>
                        <div class="particulars">{{item.course_name.length>10?item.course_name.substring(0,10)+'...':item.course_name}}</div>
                        <div class="prices">
                            <span class="price">￥{{item.course_price}}</span>
                            <span class="span"></span>
                            <img class="img2" src="@/assets/date.png" alt=""/>
                            <span class="knob">{{item.cnt_course}}节</span>
                            <img class="img3" src="@/assets/coupon.png" alt="" v-if="item.is_coupon" style="width: 62px;height: 20px;"/>
                            <img class="img3" src="@/assets/group.png" alt="" v-if="item.is_group" style="width: 46px;height: 20px;" />
                            <img class="img3" src="@/assets/xs.png" alt="" v-if="item.is_discount" style="width: 69px;height:20px;"/>
                            <img class="img3" src="@/assets/vip-icon.png" alt="" v-if="item.level_free == 1" style="width: 69px;height:20px;"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        // 推荐课程
        r_course_list: [],
        page: 1
      }
    },
    mounted () {
      this.get_course_list()
    },
    methods: {
      // 获取课程
      get_course_list () {
        //   热门课程参数
        let query = {
          is_hot: '1',
          level_free: '0',
          is_fine: '0',
          is_home: "0",
          page: 1,
          page_size: '8'
        }
        //   食品安全课程参数
        // let query = {
        //   is_fine: 1, // 	1精品
        //   is_home: 1, // 	1 推荐
        //   page_size: 4,
        //   page: this.page
        // }
        this.API.post('Home/course_out-get_course_list', query).then((res) => {
          this.r_course_list = res.data.course_list
        })
      },
    }
  }
</script>

<style lang="less" scoped>
    .recommend {
        margin-top: 15px;
        overflow: hidden;
        border-bottom: 1px solid #eee;

        .head {
            height: 59px;
            margin-bottom: 20px;

            .img {
                float: left;
                width: 59px;
                height: 54px;
            }

            .span {
                line-height: 59px;
                margin-left: 26px;
                font-size: 36px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #333333;
            }

            .span2 {
                margin-left: 20px;
                width: 291px;
                height: 26px;
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
            }

            .span3 {
                float: right;
                line-height: 59px;
                margin-right: 31px;
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
            }

            .img2 {
                float: right;
                width: 13px;
                height: 21px;
                margin: 19px 10px 0 -22px;
            }
        }

        .one {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .commodity {
                width: 282px;
                height: 300px;
                margin-bottom: 20px;
                //   background-color: pink;
                .commoditys {
                    position: relative;
                    height: 380px;

                    .img {
                        width: 282px;
                        height: 184px;
                        border-radius: 10px;
                    }

                    .img1 {
                        position: absolute;
                        left: 17px;
                        top: 0;
                        width: 120px;
                        height: 52px;
                    }

                    .particulars {
                        width: 282px;
                        font-size: 24px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #333333;
                        line-height: 40px;
                        padding: 5px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }

                    .prices {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        margin-bottom: 30px;

                        .price {
                            font-size: 28px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            color: #d53434;
                            margin-right: 10px;
                        }

                        .span {
                            width: 1px;
                            height: 20px;
                            border-right: 1px solid #ccc;
                            background: #bfbfbf;
                        }

                        .img2 {
                            width: 22px;
                            height: 22px;
                            margin-right: 5px;
                            margin-left: 5px;
                        }

                        .knob {
                            font-size: 24px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #666666;
                            margin-right: 17px;
                        }

                        .img3 {
                            width: 46px;
                            height: 20px;
                            margin-left: 5px;
                        }
                    }
                }
            }
        }
    }
</style>
